import {
  OTHER_OPTION_ISO,
  OTHER_OPTION_SBA,
  FLAG_YES,
  PAGE_TYPE_CH_GROUP,
  PAGE_TYPE_DETAIL,
  PAGE_TYPE_PROGRAM_MANAGERS,
  PAGE_TYPE_SMALL_BUSINESS,
  PAGE_TYPE_BUSINESS_BREAKDOWN,
} from "../constants.js";

/**
 * @typedef {import("../jsdoc/ContractHolder.js").ContractHolder} ContractHolder
 */

/**
 * Determines based on path whether to display contract list or contract detail page
 * @param {string} path
 * @returns {{
 *  type: PAGE_TYPE_DETAIL | PAGE_TYPE_CH_GROUP | PAGE_TYPE_PROGRAM_MANAGERS | PAGE_TYPE_SMALL_BUSINESS,
 *  id: number | undefined
 * }} What page to display
 */
export const getDisplayType = (path) => {
  const pathArray = path.split("/");
  if (pathArray.length === 3 && pathArray[1] === PAGE_TYPE_DETAIL && Number.isInteger(Number(pathArray[2]))) {
    return { type: PAGE_TYPE_DETAIL, id: Number(pathArray[2]) };
  } else if (
    (pathArray.length === 1 && pathArray[0] === "") ||
    (pathArray.length === 2 && pathArray[1] === PAGE_TYPE_CH_GROUP)
  ) {
    return { type: PAGE_TYPE_CH_GROUP };
  } else if (pathArray.length === 2 && pathArray[1] === PAGE_TYPE_PROGRAM_MANAGERS) {
    return { type: PAGE_TYPE_PROGRAM_MANAGERS };
  } else if (pathArray.length === 2 && pathArray[1] === PAGE_TYPE_SMALL_BUSINESS) {
    return { type: PAGE_TYPE_SMALL_BUSINESS };
  } else if (pathArray.length === 2 && pathArray[1] === PAGE_TYPE_BUSINESS_BREAKDOWN) {
    return { type: PAGE_TYPE_BUSINESS_BREAKDOWN };
  } else {
    return { type: null };
  }
};

/**
 * Filters Contract Holders based on provided filter options
 * @param {ContractHolder[]} contractHolders list of all contract holders
 * @param {Object} options options for how contract holders list should be filtered
 * @param {Object} options.groupOptions
 * @param {string} options.groupOptions.group
 * @param {string} options.groupOptions.facet
 * @param {number[]} options.otherOptions
 * @returns {ContractHolder[]} list of filtered contractHolders based on options provided
 */
export const filterContractHolders = (contractHolders, options) => {
  const { groupOptions, otherOptions } = options;

  if (otherOptions.includes(OTHER_OPTION_ISO)) {
    contractHolders = contractHolders.filter(({ isoCertified }) => isoCertified === FLAG_YES);
  }

  if (otherOptions.includes(OTHER_OPTION_SBA)) {
    contractHolders = contractHolders.filter(({ sbaCertified }) => sbaCertified === FLAG_YES);
  }

  if (groupOptions.group) {
    contractHolders = contractHolders.filter(({ group }) => group === groupOptions.group);
    if (groupOptions.facet) {
      contractHolders = contractHolders.filter(({ businessSizes }) =>
        businessSizes
          .split(",")
          .map((size) => size.trim())
          .includes(groupOptions.facet)
      );
    }
  }
  return contractHolders;
};

export const getOptionName = ({ group = "All Groups", facet = "" }) => `${group} ${facet}`;
